"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Captcha = require("./Captcha");
Object.keys(_Captcha).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Captcha[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Captcha[key];
    }
  });
});